import { Component, Input } from '@angular/core';
import { NavigatorService } from '@m4u-angular/core/framework/navigator.service';
import { EnumGridModes } from '@m4u-angular/core/framework/sysenums.enum';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
    selector: 'm4u-gridbuttonadd',
    templateUrl: './gridbuttonadd.component.html',
    styleUrls: ['./gridbuttonadd.component.scss']
})
export class GridButtonAddComponent {
    @Input() Text: string;
    @Input() Type: string;

    @Input() WindowPath: string;
    @Input() WindowParams: any;
    
    constructor(private navigator: NavigatorService) { }

    @Input() public grid: DxDataGridComponent;
    get gridAny(): any { return this.grid; }

    get IsGridEditable() {
        return this.gridAny && this.gridAny.G && this.gridAny.G.Mode === EnumGridModes.Editable;
    }

    get IsDisabled() {
        return this.IsGridEditable && !this.gridAny.G.IsNewRowCreatable();
    }

    OnClick() {
        this.IsGridEditable
            ? this.gridAny.G.CreateNewRow()
            : this.navigator.Navigate([this.WindowPath], this.WindowParams);
    }
}